import { useMutation } from '@apollo/client/react';
import { CANCEL_ORDER_INVOICE_MUTATION } from './useCancelOrderInvoiceMutation.gql';
export const useCancelOrderInvoiceMutation = () => {
  return useMutation(CANCEL_ORDER_INVOICE_MUTATION);
};
